// Dialogue TinyMCE natif pour insertion d'image

import { I18nStrings } from '../../i18n';
import { CardFace } from '../../types/flipcardTypes';
import flipcardImageUtils from "@/components/tinyMce/plugins/flipcard/flipcardImageUtils";

export class NativeDialog {
  private readonly editor: any;
  private readonly i18n: I18nStrings;

  constructor(editor: any, i18n: I18nStrings) {
    this.editor = editor;
    this.i18n = i18n;
  }

  public openImageDialog(imageUploadUrl: string): Promise<string | null> {
    let imgBlobUrl: string = '';
    return new Promise((resolve) => {
      const dialogConfig = {
        title: this.i18n.insertImage,
        body: {
          type: 'panel',
          items: [
            {
              type: 'dropzone',
              name: 'imageFile',
              label: this.i18n.uploadFile
            },
            {
              type: 'htmlpanel',
              name: 'preview',
              html: '<div id="image-preview" style="display:none; margin-top:8px; text-align: center;"><img style="max-width:100%; max-height:200px;"/></div>'
            }
          ]
        },
        buttons: [
          {
            type: 'cancel',
            text: this.i18n.cancel
          },
          {
            type: 'submit',
            text: this.i18n.ok,
            primary: true
          }
        ],
        onSubmit: async (api: any) => {
          const data = api.getData();
          if (data.imageFile && data.imageFile.length > 0) {
            api.close();
            const file = data.imageFile[0];
            let imgUrl: string = '';
            if (file) {
              try {
                imgUrl = await flipcardImageUtils.uploadImage(file, imageUploadUrl);
              } catch (error) {
                console.log('An error has occurred.', error);
                this.editor.dispatch('flipCardImageUploadApiError');
              } finally {
                if (imgBlobUrl) {
                  URL.revokeObjectURL(imgBlobUrl);
                }
                resolve(imgUrl);
              }
            }
          } else {
            api.close();
            if (imgBlobUrl) {
              URL.revokeObjectURL(imgBlobUrl);
            }
            resolve(null);
          }
        },
        onCancel: () => {
          if (imgBlobUrl) {
            URL.revokeObjectURL(imgBlobUrl);
          }
          resolve(null);
        }
      };

      this.editor.windowManager.open(dialogConfig);

      setTimeout(() => {
        const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
        if (fileInput) {
          fileInput.addEventListener('change', (e) => {
            handleFileInputChange(e);
          });
        }
      }, 100);

      function handleFileInputChange(e: Event) {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (file) {
          // Afficher preview
          const reader = new FileReader();
          reader.onload = (event) => {
            const preview = document.getElementById('image-preview');
            const img = preview?.querySelector('img');
            if (img) {
              img.src = event.target?.result as string;
              preview!.style.display = 'block';
            }
          };
          reader.readAsDataURL(file);
        }
      }

    });
  }

  public async handleImageInsertion(cardId: string, face: CardFace, imageUploadUrl: string): Promise<void> {
    const imageUrl = await this.openImageDialog(imageUploadUrl);

    if (imageUrl) {
      this.editor.execCommand('flipcardInsertImage', false, {
        cardId,
        face,
        imageUrl
      });
    }
  }
}
